import QuantityProduct from './QuantityProduct'

class DigitalRetouchedPeoplePhotoProduct extends QuantityProduct {}

export default DigitalRetouchedPeoplePhotoProduct
